import { Component, OnInit, Inject } from '@angular/core';
import { AuthStoreDispatcher } from 'src/app/core/state/auth/auth.dispatcher';
import {
    Validators,
    FormControl,
} from '@angular/forms';
import { SopoDialogRef, SOPO_DIALOG_DATA } from 'src/app/sopo-popup/interfaces/dialog';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    standalone: false
})
export class ForgotPasswordComponent implements OnInit {
    errorFlag = false;
    forgotPasswordEmail: FormControl;
    validationMessages = {
        email: [
            { type: 'required', message: 'Email is required.' },
            {
                type: 'email ',
                message: 'Invalid email address.' 
            },
        ],
    }

    constructor(
        public sopoDialogRef: SopoDialogRef,
        @Inject(SOPO_DIALOG_DATA) public data: any,
        private authService: AuthStoreDispatcher,
    ) {}

    ngOnInit() {
        this.forgotPasswordEmail = new FormControl(
            null,
            [
                Validators.required,
                Validators.email
            ]
        );
    }

    async submit() {
        if (this.forgotPasswordEmail.valid) {
            this.sopoDialogRef.close();
            this.authService.resetPassword(this.forgotPasswordEmail.value);
        } else
            this.errorFlag = true;
    }
    
    dismiss() {
        this.sopoDialogRef.close();
    }
}
